<template>
  <el-dialog
    title="清除本月数据"
    :visible.sync="dialogVisible"
    width="650px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <template>
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-form-item prop="tenantGuid">
          <span slot="label">药企名称：</span>
          <el-select
            v-model="form.tenantGuid"
            filterable
            placeholder="请选择"
            class="ipt-sty w80f fl"
            @change="handleTenantChange"
          >
            <el-option
              v-for="item in companyList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="organisationGuid">
          <span slot="label">组织名称：</span>
          <el-select
            v-model="form.organisationGuid"
            filterable
            clearable
            placeholder="请选择"
            class="ipt-sty w80f fl"
            :loading="organisationLoading"
            @focus="handleOrganisationFocus"
          >
            <el-option
              v-for="item in organisationList"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="accountMonth">
          <span slot="label">核算月份：</span>
          <el-date-picker
            class="ipt-sty w80f fl"
            value-format="yyyy-MM"
            v-model="form.accountMonth"
            type="month"
            placeholder="选择月"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button
          size="medium"
          type="info"
          :loading="submitLoading"
          @click="submit"
          >确 定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
import serverConfig from "@/assets/global/serverConfig";
import { deleteTaskSalary } from "@/api/msSalesPerformService";
import { getOrganisationList } from "@/api/msPersonnelService";

export default {
  name: "ClearCurrentMonthDataDialog",
  props: {
    companyList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
      form: this.getDefaultForm(),
      organisationList: [],
      organisationLoading: false,
      submitLoading: false,
      rules: {
        tenantGuid: [
          { required: true, message: "请选择药企名称", trigger: "change" },
        ],
        organisationGuid: [
          { required: true, message: "请选择组织", trigger: "change" },
        ],
        accountMonth: [
          { required: true, message: "请选择核算月份", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true;
    },
    // 获取默认表单数据
    getDefaultForm() {
      return {
        tenantGuid: "",
        organisationGuid: "",
        accountMonth: "",
      };
    },
    // 关闭弹窗
    handleClose() {
      this.form = this.getDefaultForm();
      this.organisationList = [];
      this.submitLoading = false;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    // 处理药企名称改变
    handleTenantChange(tenantGuid) {
      this.form.organisationGuid = "";
      this.organisationList = [];
      if (tenantGuid) {
        this.loadOrganisationList(tenantGuid);
      }
    },
    // 处理组织名称改变
    handleOrganisationFocus() {
      if (!this.form.tenantGuid) {
        this.$message.error("请选择药企名称!");
      }
    },
    // 获取组织列表
    async loadOrganisationList(tenantGuid) {
      const query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid,
      };
      this.organisationLoading = true;
      const { data } = await getOrganisationList(query);
      this.organisationLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.organisationList = data.data.records || [];
    },
    // 提交
    async submit() {
      const valid = await this.$refs.formRef.validate().catch(() => false);
      if (!valid) {
        return;
      }
      const req = {
        tenantGuid: this.form.tenantGuid,
        organisationGuid: this.form.organisationGuid,
        accountMonth: this.form.accountMonth.replace("-", ""),
      };
      this.submitLoading = true;
      const { data } = await deleteTaskSalary(req);
      this.submitLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.$message.success("清除成功");
      this.dialogVisible = false;
      this.$emit("success");
    },
  },
};
</script>
